import { RouteObject } from 'react-router';

import { LoginPageLazy } from './page.tsx';

import { EAdminRoutes } from '@/services/router/enums';

export const LOGIN_ROUTE: RouteObject = {
    path: EAdminRoutes.Login,
    element: <LoginPageLazy />,
};
